// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OJz2D","content":"styles_content__2FYCG"};